module.exports = __webpack_public_path__ + "img/glamBubble.c5fbb2cb.jpg";